<template>
  <div>
    <label class="item-name"><i class="required" v-show="component.properties.required">*</i>{{initComponent.name}}</label>
    <div class="component-content">
      <el-input :class="{onlyread:component.properties.readonly}" disabled/>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-id-card',
  props: ['initComponent'],
  inject: ['formService'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  },
  methods: {
    remove () {
      for (let attr in this.component.properties.discriminate) {
        if (this.component.properties.discriminate[attr] && this.component.properties.discriminate[attr] !== '') {
          let component = this.formService.getComponentById(this.component.properties.discriminate[attr])
          this.formService.removeComponent(component)
        }
      }
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/form/components/idcard/rc-id-card.vue